import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/uiconfig';
import { useAuthentication, AUTH_ERRORS } from 'gw-digital-auth-react';
import AuthMessageComponent from '../AuthMessageComponent/AuthMessageComponent';
import { isEmpty, checkEmailValidity } from '../LoginUtil';

import messages from './ForgotUsernameComponentExt.messages';
import metadata from './ForgotUsernameComponentExt.metadata.json5';
import styles from '../CommonLogin.module.scss';

function ForgotUsernameComponentExt(props) {
    const translator = useTranslator();
    const [formData, updateFormData] = useState({});
    const [pageError, updatePageError] = useState();
    const [pageView, setPageView] = useState();
    const { forgotUsernameExt, authHeader } = useAuthentication();
    const { onBackToSignIn } = props;

    const handleForgotUsername = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }
            const policynumber = _.get(formData, 'policynumber');
            const email = _.get(formData, 'email');
            if (isEmpty(email) || !checkEmailValidity(email) || isEmpty(policynumber)) {
                updatePageError(AUTH_ERRORS.fieldIncorrect);
                return Promise.resolve();
            }
            return forgotUsernameExt(email, policynumber, authHeader)
                .then(() => {
                    setPageView('success');
                })
                .catch((err) => {
                    switch (err.error) {
                        case AUTH_ERRORS.emailNotFound:
                            setPageView(AUTH_ERRORS.emailNotFound);
                            break;
                        default:
                            setPageView(AUTH_ERRORS.invalidAttempt);
                            break;
                    }
                });
        },
        [authHeader, formData, forgotUsernameExt]
    );

    // const readValue = useCallback(() => email, [email]);
    // const writeValue = useCallback((value) => updateEmail(value), []);
    const readValue = useCallback(
        (id, path) => {
            return _.get(formData, path);
        },
        [formData]
    );

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );
    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleBackToSignIn: onBackToSignIn
        },
        resolveComponentMap: {
            authmessagecomponent: AuthMessageComponent
        }
    };

    const overrides = {
        '@field': {
            onValueChange: writeValue
        },
        errorMsg: {
            visible: !_.isUndefined(pageError),
            content: translator(messages[pageError])
        },
        emailFieldContainer: {
            visible: !pageView
        },
        forgotPasswordForm: {
            onSubmit: handleForgotUsername
        },
        actionsWrapperSingleButton: {
            className: classNames(styles.actionsWrapperSingleButton, {
                [styles.coupleButtonStyle]: !_.isUndefined(onBackToSignIn),
                [styles.singleButtonStyle]: _.isUndefined(onBackToSignIn)
            })
        },
        sendButton: {
            onTrigger: handleForgotUsername
        },
        linkToSignIn: {
            visible: !_.isUndefined(onBackToSignIn)
        },
        invalidAttemptError: {
            visible: pageView === AUTH_ERRORS.invalidAttempt
        },
        invalidEmailError: {
            visible: pageView === AUTH_ERRORS.emailNotFound
        },
        successfulContainer: {
            visible: pageView === 'success'
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

ForgotUsernameComponentExt.propTypes = {
    onBackToSignIn: PropTypes.func
};

ForgotUsernameComponentExt.defaultProps = {
    onBackToSignIn: undefined
};

export default ForgotUsernameComponentExt;
